export const XmarkRegular = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.54,19.42c.59,.58,.59,1.53,0,2.12s-1.54,.58-2.13,0l-7.41-7.43-7.46,7.43c-.59,.58-1.54,.58-2.13,0s-.59-1.53,0-2.12l7.46-7.43L2.42,4.51c-.59-.58-.59-1.53,0-2.12,.59-.59,1.54-.58,2.13,0l7.46,7.49,7.46-7.43c.59-.58,1.54-.58,2.13,0s.59,1.53,0,2.12l-7.46,7.43,7.41,7.43Z" />
    </svg>
  );
};
